import axios from '@services/service';

// import { chunk } from 'lodash';


export async function getLiveInfo(params: {
  userId: string;
  authorId: string;
  kpn: string;
}) {
    try {
        const { userId, kpn, authorId } = params;
        const res = await axios.post<any >('/live/api/share/info', {
            userId,
            authorId,
            kpn,
        });
        return res;
    } catch (error) {
        return [];
    }
}